import React from "react";
import { ConfirmModal } from "./ui";

/**
 * The app's confirm dialog. Kept as a thin wrapper over the design system's
 * ConfirmModal so the existing call sites — which pass title/content/action —
 * keep working unchanged.
 */
const Modal = ({ title, content, onConfirm, onCancel, action, disabled }) => (
  <ConfirmModal
    title={title}
    message={content}
    confirmLabel={action || "Delete"}
    busy={disabled}
    onConfirm={onConfirm}
    onCancel={onCancel}
  />
);

export default Modal;
